// @flow
import React from 'react'
import Row from './Row'
import Ref from 'components/References/Ref'
import formatters from 'lib/formatters'
import styles from './styles'

type Props = {
  dateOfDeath: Date,
  openDateOfDeathModal: Function
}

const DateOfDeathRef = (props: Props) => {
  const {
    dateOfDeath,
    openDateOfDeathModal
  } = props

  const showEditLink = () => <a
    className={styles.dodLink}
    onClick={() => openDateOfDeathModal()}>
        Edit
    </a>

  let dodDisplay
  if (!dateOfDeath) {
    dodDisplay = 'Not Deceased'
  } else if (dateOfDeath === '1900-01-01') {
    dodDisplay = 'Unknown'
  } else if (new Date(dateOfDeath) > new Date('1900-01-01')) {
    dodDisplay = formatters.date(dateOfDeath)
  }

  return (
    <Ref
      title="Date of Death"
      preview={
        <div>
          <Row
            singleLine
            label={dodDisplay}
            val={showEditLink()}
            mono={true}
          />
        </div>
      }
    />
  )
}

export default DateOfDeathRef
